import { z } from 'zod';

// Widget types are kebab-case so they're safe to put in a SQL text enum, URL paths,
// and discriminator fields.
export const widgetTypes = [
  'progress-snapshot',
  'investment-balance',
  'health-alerts',
  'dependency-analysis',
  'missing-data',
] as const;
export const widgetTypeSchema = z.enum(widgetTypes);
export type WidgetType = z.infer<typeof widgetTypeSchema>;

export const widgetDTOSchema = z.object({
  widgetId: z.number().int(),
  organizationId: z.string().min(1),
  loopId: z.number().int(),
  type: widgetTypeSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type WidgetDTO = z.infer<typeof widgetDTOSchema>;

export function parseWidgetDTO(data: unknown): WidgetDTO {
  return widgetDTOSchema.parse(data);
}

export const widgetInsertDTOSchema = z
  .object({
    loopId: z.number().int(),
    type: widgetTypeSchema,
  })
  .strict();

export type WidgetInsertDTO = z.infer<typeof widgetInsertDTOSchema>;
